export class ClaimImportFilters {
  selectedClientIds = [];
}
